"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOREFRONT_AI_FEEDBACK_CATEGORIES = exports.STOREFRONT_AI_FEEDBACK_RATING = void 0;
exports.STOREFRONT_AI_FEEDBACK_RATING = {
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
};
exports.STOREFRONT_AI_FEEDBACK_CATEGORIES = [
    'visual_appeal',
    'image_video_selection',
    'brand_mismatch',
    'copy_wording',
    'product_selection',
    'broken',
    'other',
];
